// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Button, Grid } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
// import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import { getStorages } from 'src/services/storage.service';
import React from 'react';
import DropboxStatusCheckAndConnect from 'src/components/cloud_services/dropbox/DropboxStatusCheckAndConnect';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleDriveStatusCheckAndConnect from 'src/components/cloud_services/googledrive/GoogleDriveStatusCheckAndConnect';
// import Search from 'src/components/common/search';
// import LanguagePopover from './LanguagePopover';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import OnedriveStatusAndSync from 'src/components/cloud_services/onedrive/OnedriveStatusAndSync';
import SidebarOpenIcon from 'src/assets/icons/sidebar-open.svg';
import SidebarCloseIcon from 'src/assets/icons/sidebar-close.svg';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 70;

const HEADER_DESKTOP = 70;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    // width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

class Header extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      available_storages: [],
    };
  }

  async componentDidMount() {

    let available_storages = await getStorages();
    if (!available_storages.error) {
      this.setState({
        available_storages: available_storages.storages
      })
    }
  }

  render() {

    const pathname = this.props.location.pathname;

    return (
      <StyledRoot>
        <StyledToolbar>

          {/* TODO : Change icon here */}
          <IconButton
            onClick={this.props.onOpenNav}
            sx={{
              mr: 1,
              color: 'text.primary',
            }}
          >
            <img src={SidebarOpenIcon} alt="sidebar open" style={{ width: '24px', height: '24px' }} />

            {/* <Iconify icon="eva:menu-2-fill" /> */}
          </IconButton>

          <Box
            component="img"
            src="/assets/images/logo.png"
            alt="logo"
            sx={{
              width: 100,
              cursor: 'pointer',
            }}
            onClick={() => {
              window.location.href = '/files/view';
            }}
          />

          <Box sx={{ flexGrow: 1, alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            {/* {pathname === '/files/view' ? (
              <Search />
            ) : null} */}
          </Box>

          <Stack
            direction="row"
            alignItems="center"
            spacing={{
              xs: 0.5,
              sm: 1,
            }}
          >

            <Grid display={'flex'} flexDirection={'row'}>
              {/* {(this.state.available_storages.map((storage) => {
                if (storage.type === 'onedrive') {
                  return (
                    <OnedriveStatusAndSync
                      key={storage._id}
                      serviceId={storage._id}
                      displayType="icon"
                    />
                  )
                }
                if (storage.type === 'dropbox') {
                  return (
                    <DropboxStatusCheckAndConnect
                      key={storage._id}
                      storageId={storage._id}
                      hideUnsyncButton={true}
                      minimal={true}
                      callbackUrl={process.env.REACT_APP_DROPBOX_DASHBOARD_CALLBACK_URL}
                    />
                  )
                }
                if (storage.type === 'googledrive') {
                  return (
                    <GoogleOAuthProvider
                      clientId={process.env.REACT_APP_GOOGLEDRIVE_CLIENT_ID}
                      key={storage._id}
                    >
                      <GoogleDriveStatusCheckAndConnect
                        storageId={storage._id}
                        hideUnsyncButton={true}
                        minimal={true}
                        callbackUrl={process.env.REACT_APP_GOOGLEDRIVE_DASHBOARD_CALLBACK_URL}
                      />
                    </GoogleOAuthProvider>
                  )
                }
              }))} */}

              {(this.state.available_storages.length === 0) ? (
                <Button
                  variant="contained"
                  size="small"
                  // sx={{ mr: 5 }}
                  href="https://youtu.be/scRcc4c6yiQ?t=26"
                  target="_blank"
                >
                  Get Started
                </Button>
              ) : null}

            </Grid>


            {/* <LanguagePopover /> */}
            {/* <NotificationsPopover /> */}
            {/* <AccountPopover /> */}
          </Stack>
        </StyledToolbar>
      </StyledRoot>
    );
  }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <Header {...props} navigate={navigate} location={location} params={params} />;
}
